module.exports = __webpack_public_path__ + "img/de_get.12c822b.png";